import { useMemo } from "react";
import { Helmet } from "react-helmet";
import { useAuth } from "../providers/AuthProvider";

// thought process is to avoid having to get the client name on multple pages, can just prepend the title to the {clientName} | Wripple
// plan to make this more dynamic

const WrippleHelmet = ({ title, hideClient = false, hideBrand = false }) => {
    const { auth } = useAuth();
    const clientName = useMemo(() => auth.clientOrg()?.name, [auth?.client_organization?.name]);

    const titleName = useMemo(() => {
        const titleItems = []

        if (title) {
            titleItems.push(title)
        }

        if (!hideClient && clientName) {
            titleItems.push(clientName)
        }

        if (!hideBrand) {
            titleItems.push('Wripple')
        }

        return titleItems.join(' | ')
    }, [title, clientName])

    return (
        <Helmet>
            {/* <title>{clientName} | Wripple</title> */}
            <title>{titleName}</title>
        </Helmet>
    )
}

export default WrippleHelmet;
